import Card from './CardIndex';

export { default as CardHeader } from './components/CardHeader';

export default Card;
